import { useContext } from 'react'
import { InputVarsContext } from '../../contexts/input-vars-context'
import { dateHandler } from '../../utilities/date-utils'
import { useResponseMessages } from '../../hooks/useResponseMessage'

const DateRangePicker = ({ onStartDateChange, onEndDateChange }) => {
    const { vars, setVars } = useContext(InputVarsContext)
    const { addMessage } = useResponseMessages();

    const handleStartDateChange = (e) => {
        const updatedDate = dateHandler.toZeroHoursFormat(dateHandler.toNearestValidDate(e.target.value));

        if (!updatedDate) {
            addMessage({
                error: 'Please select a valid end date.',
            });
            return;
        }

        if (!updatedDate || updatedDate.getTime() === vars.dateRange.startDate.getTime()) {
            return;
        }

        if (updatedDate.getTime() > vars.dateRange.endDate.getTime()) {
            addMessage({
                error: 'Start date cannot be after end date.',
            });
            return;
        }

        setVars({
            ...vars,
            dateRange: {
                ...vars.dateRange,
                startDate: updatedDate
            },
        })

        if (onStartDateChange) {
            onStartDateChange(e.target.value)
        }
    }

    const handleEndDateChange = (e) => {
        const updatedDate = dateHandler.toZeroHoursFormat(dateHandler.toNearestValidDate(e.target.value));
        const normalizedEndDate = dateHandler.toZeroHoursFormat(vars.dateRange.endDate);

        if (!updatedDate) {
            addMessage({
                error: 'Please select a valid end date.',
            });
            return;
        }

        if (!updatedDate || updatedDate.getTime() === normalizedEndDate.getTime()) {
            return;
        }

        if (updatedDate.getTime() < vars.dateRange.startDate.getTime()) {
            addMessage({
                error: 'End date cannot be before start date.',
            });
            return;
        }

        setVars({
            ...vars,
            dateRange: {
                ...vars.dateRange,
                endDate: updatedDate
            },
        })

        if (onEndDateChange) {
            onEndDateChange(e.target.value)
        }
    }

    if (!vars.dateRange.startDate || !vars.dateRange.endDate) {
        return null
    }

    return (
        <div className="formFieldRow">
            <div className="formField">
                <label>Start</label>
                <input
                    type="date"
                    defaultValue={dateHandler.toInputFormat(vars.dateRange.startDate)}
                    onBlur={handleStartDateChange}
                />
            </div>

            <div className="formField">
                <label>End</label>
                <input
                    type="date"
                    defaultValue={dateHandler.toInputFormat(vars.dateRange.endDate)}
                    onBlur={handleEndDateChange}
                />
            </div>
        </div>
    )
}

export default DateRangePicker